const paramRegEx = /:.*\//g;

export function convertPathToRegEx(path: string): RegExp {
  const regExString = path.replace(paramRegEx, '[^\\/]*/');
  return new RegExp(regExString);
}
